import * as React from 'react';
import { withLocalize, LocalizeContextProps, Translate } from "react-localize-redux";
import bindAllOfThis from 'src/utils/BindThisHelper';
import Routes from 'src/core/Routes';
import { Row, Col, Button } from "antd";
import DialogBox from "src/components/mission/DialogBox";
import { EnhancedProps } from 'src/pages/student/models/props';
import InfoBox from "src/components/mission/InfoBox";
import { Link } from "react-router-dom";
import { Planets } from "src/constants/Planets";
import { Grades } from "src/constants/Grades";
import AudioTranslations from "src/constants/AudioTranslations";

interface SpaceStationCeremonyProps extends EnhancedProps, LocalizeContextProps {
}

class SpaceStationCeremony extends React.Component<SpaceStationCeremonyProps> {
    constructor(props: SpaceStationCeremonyProps) {
        super(props);
        bindAllOfThis(this, SpaceStationCeremony.prototype);
    }

    hasNextButton(): boolean {
        return true;
    }

    hasBackButton(): boolean {
        return false;
    }

    onNext(): void {
        this.props.onNext();
    }

    onBack(): void {
        this.props.onBack();
    }

    private renderCompletionBadge() {
        //let grade = Grades.FindById(this.props.User.gradeId);
        let rewardsPath = Grades.GetCeremonyRewardsPath(this.props.User.gradeId);
        //return <img className="galaxy-award" alt="Grade Award" src={grade.rewardsPath} key={`award${grade.id}`} />;
        return <img className="galaxy-award" alt="Grade Award" src={rewardsPath} />;
    }

    render() {
        // Note: title is combined with body in audio file because it is so much easier this way
        let translationKey = "student.galaxyCeremony.grade%gradeNumber%"
            .replace("%gradeNumber%", this.props.currentGrade.shortName);
        let headerKey = `student.galaxyCeremony.title`;
        let bodyKey = `${translationKey}.body`;
        let audioTrans = AudioTranslations.FindByKeyAndLanguage(bodyKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);

        return <Row className="galaxy-ceremony">
            <Col className="dialog-content" xs={{ span: 22, push: 1 }} md={{ span: 16 }} xl={14}>
                <Row>
                    <DialogBox
                        currentGrade={this.props.currentGrade}
                        currentPlanet={this.props.currentPlanet}
                        buttonNextType={this.hasNextButton() ? "arrow" : "none"}
                        buttonBackType={this.hasBackButton() ? "arrow" : "none"}
                        onBack={this.onBack}
                        onNext={this.onNext}>
                        <h2 className="galaxy-ceremony-header"><Translate id={headerKey} /></h2>
                        <p className="galaxy-ceremony-body"><Translate id={bodyKey} /></p>
                        <div className="galaxy-ceremony-container">
                            {this.renderCompletionBadge()}
                        </div>
                    </DialogBox>
                </Row>
            </Col>
            <Col xs={23} md={{ span: 7, push: 1 }} xl={9}>
                <Row type="flex" justify="space-between">
                    <Col xs={{ span: 23, push: 1 }} lg={{ span: 20, push: 4 }}>
                        <InfoBox currentGrade={this.props.currentGrade} currentPlanet={this.props.currentPlanet} />
                    </Col>
                </Row>
                <Row type="flex" justify="space-between">
                    <Col xs={{ span: 20, push: 2 }} lg={{ span: 21, push: 1 }}>
                        <img className="station-commander" alt={`Commander ${this.props.currentGrade.commander}`} src={this.props.currentGrade.commanderPath} height="100%" width="100%" />
                    </Col>
                </Row>
            </Col>
        </Row>;
    }
}

export default withLocalize(SpaceStationCeremony);



// WEBPACK FOOTER //
// ./src/pages/student/scenes/SpaceStationCeremony.tsx